import { FC, useContext, useState } from 'react';

import { Tabs } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { ShellPassword, SmartLockPassword } from './components';
import s from './HighPassword.module.scss';

export const HighPassword: FC = () => {
  const { t } = useContext(LocalizationContext);
  const [tab, setTab] = useState<'Shell' | 'SmartLock'>('Shell');

  return (
    <>
      <Tabs
        options={[
          { title: t('host.ctx.shell'), value: 'Shell' },
          { title: 'SmartLock TV', value: 'SmartLock' },
        ]}
        onChange={(value: 'Shell' | 'SmartLock') => setTab(value)}
        value={tab}
        className={s.tab}
      />
      {tab === 'Shell' && <ShellPassword />}
      {tab === 'SmartLock' && <SmartLockPassword />}
    </>
  );
};
